import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ErrorService } from '../../error';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CampaignModel } from './types';
import { CrudType } from '../../service/message/types';
import { MessageService } from '../../service/message/message.service';
import { ListItem } from '../typeahead/types';

@Injectable({
  providedIn: 'root',
})
export class CampaignApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
    private readonly messageService: MessageService,
  ) {}

  getById = (id: number): Observable<CampaignModel> => {
    let parameters: string[];
    parameters = [id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<CampaignModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  getList = (): Observable<ListItem[]> => {
    let parameters: string[];
    parameters = ['list'];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ListItem[]>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  createInstance = (): Observable<CampaignModel> => {
    let parameters: string[];
    parameters = ['create'];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<CampaignModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  postCampaign = (campaignModel: CampaignModel): any => {
    let parameters: string[];
    parameters = [];
    let url = this.formatUrl(parameters);
    return this.httpClient
      .post<CampaignModel>(url, campaignModel, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.create),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  updateCampaign = (campaignModel: CampaignModel): any => {
    let parameters: string[];
    parameters = [campaignModel.id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient
      .put<CampaignModel>(url, campaignModel, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.update),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.campaign.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
